import { all } from 'redux-saga/effects';

import consultaProcessosAdministrativosSaga from './processosAdministrativos/saga';

export default all([consultaProcessosAdministrativosSaga]);
